<header class="font-bold flex items-center" [ngClass]="sized">
  <Icon *ngIf="icon" [src]="icon" class="me-2"/>
  {{title}}
</header>
<p *ngIf="subtitle"class="text-md">{{subtitle}}</p>
